module.exports = __webpack_public_path__ + "ao.no1.014417b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ao.no1.jpg
// module id = z+qb
// module chunks = 0